import jQuery from 'jquery';
import { forEach } from 'lodash';

jQuery(($) => {
  'use strict';

  let requestForm = $('#RecordRequest');

  if (requestForm.length > 0) {
    requestForm.on('submit', (e) => {
      if ($('#token').val() === '') {
        e.preventDefault();

        grecaptcha.enterprise.ready(() => {
          grecaptcha.enterprise.execute(
            window.recaptchaSiteKey,
            {
              action: 'recordrequest'
            }
                    )
                    .then((token) => {
                      $('#token').val(token);
                      $('#RecordRequest').submit();
                    });
        });
      }
    });

    requestForm.find('input').attr('autocomplete', 'off');

    let accordion = $('#Accordion');

    // Enable address autocompletion on the NOR fields
    try {
      decorateAddressCompletion('request[nor]');
    } catch (err) {
      console.error(err);
    }

    // Enable address autocompletion on the adjuster fields
    try {
      decorateAddressCompletion('request[adjuster]');
    } catch (err) {
      console.error(err);
    }

    // Enable address completion on each existing deponent
    $('.depRow').each((index) => {
      try {
        decorateAddressCompletion('request[deponents][' + index + ']');
      } catch (err) {
        console.error(err);
      }
    });

    // Enable address completion on each existing attorney
    $('.counselRow').each((index) => {
      try {
        decorateAddressCompletion('request[attorneys][' + index + ']');
      } catch (err) {
        console.error(err);
      }
    });

    accordion.accordion({
      heightStyle: 'content'
    }).show();

    accordion.accordion({
      create: $.noop
    });

    $('#Dialog').dialog({
      autoOpen: false,
      show: 'fade',
      hide: 'fade'
    });

    // Case Entry Switcher
    $('input[name="request[court_case][entry_method]"]').change((evt) => {
      let inputEl = $(evt.target);
      let inputVal = inputEl.val();

      if (inputVal === 'upload') {
        $('#entercase').hide();
        $('#uploadcase').show();
      } else {
        if (inputVal === 'enter' || inputVal === 'manual') {
          $('#entercase').show();
          $('#uploadcase').hide();
        } else {
          $('#entercase').hide();
          $('#uploadcase').hide();
        }
      }
    });

    // Billing Method Switcher
    $('input[name="request[bill_adjuster]"]').change((evt) => {
      if ($(evt.target).val() === '0') {
        $('#requestor').show();
        $('#bill3rdparty').hide();
      } else {
        $('#requestor').hide();
        $('#bill3rdparty').show();
      }
    });

    // NOR Switcher
    $('select#nor_type').change((evt) => {
      if ($(evt.target).val() === 'Organization') {
        $('#norTypeOrganization').show();
        $('#norTypeIndividual').hide();
      } else {
        $('#norTypeOrganization').hide();
        $('#norTypeIndividual').show();
      }
    });

    // AddCounsel Button
    $('#addCounsel').click(addCounsel);

    // Requestor only one allowed
    $('.chkRequestor').click((evt) => {
      $(evt.target).attr('checked', false);
      $(evt.target).prop('checked', true);
    });

    // Delete Counsel Button
    $('#counselContainer').on('click', '.deleteCounsel', (evt) => {
      evt.preventDefault();
      let $currentRow = $(evt.target).parent('div');
      let $otherRows = $currentRow.siblings('div');
      let isNoi = $('#court_case_noi').is(':checked');

      if ($otherRows.length === 0 && !!isNoi === false) {
        alert('You need to have at least one counsel.');
      } else {
        $currentRow.slideUp('slow', () => {
          $currentRow.remove();
        });
      }
    });

    // Add Deponent Button
    $('#addDep').click(addDeponent);

    // Delete Deponent Button
    $('#deponentContainer').on('click', '.deleteDep', (evt) => {
      evt.preventDefault();
      let $current_deprow = $(evt.target).parent('div');
      let $other_deprows = $current_deprow.siblings('div');

      if ($other_deprows.length === 0) {
        alert('You need to have at least one deponent.');
      } else {
        $current_deprow.slideUp('slow', () => {
          $current_deprow.remove();
        });
      }
    });

    // Step links
    $('#tabWelcome .step').click((e) => {
      e.preventDefault();
      accordion.accordion('option', 'active', 1);
    });

    $('#tabNOR a').click((e) => {
      e.preventDefault();
      accordion.accordion('option', 'active', 2);
    });

    $('#tabCase a').click((e) => {
      e.preventDefault();
      accordion.accordion('option', 'active', 3);
    });

    $('#tabDeponents a').click((e) => {
      e.preventDefault();
      accordion.accordion('option', 'active', 4);
    });

    // Input Masks
    $('.ssnmask').mask('***-**-****');
    $('.datemask').mask('99/99/9999');
    $('.datepicker').datepicker({
      yearRange: '1900:2025',
      changeMonth: true,
      changeYear: true
    });
    $('.phonemask').mask('(999) 999-9999? x99999');
  }

  /**
   * Setup a Google Maps Autocomplete field for the given selector prefix.
   *
   * @function decorateAddressCompletion
   * @param selectorPrefix
   */
  function decorateAddressCompletion(selectorPrefix) {
    let key = selectorPrefix.replace(new RegExp('[^0-9A-Za-z_]', 'gi'), ''); // Ex: request[attorneys][0]
    let autocompleteInput = $('input[name="' + selectorPrefix + '[street_1]"]');

    if (!window.placeSearch || $.type(window.placeSearch) !== 'object') {
      window.placeSearch = {};
    }

    // Create the autocomplete object, restricting the search predictions to geographical location types.
    window.placeSearch[key] = new google.maps.places.Autocomplete(autocompleteInput.get(0), {types: ['geocode']});

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components.
    window.placeSearch[key].setFields(['address_component']);

    // When the user selects an address from the drop-down, populate the
    // address fields in the form.
    window.placeSearch[key].addListener('place_changed', () => {
      try {
        fillInAddress(window.placeSearch[key], selectorPrefix);
      } catch (err) {
        console.error(err);
      }
    });
  }

  /**
   * Get the place details from the autocomplete object and fill in the address.
   *
   * @function fillInAddress
   * @param autocomplete
   * @param selectorPrefix
   */
  function fillInAddress(autocomplete, selectorPrefix) {
    // Get the place details from the autocomplete object.
    let place = autocomplete.getPlace();
    let address = translateAddress(place);
    let input, field;

    for (field in address) {
      input = $('input[name="' + selectorPrefix + '[' + field + ']"]');

      if (input.length === 1 && address.hasOwnProperty(field)) {
        input.val(address[field]);
      }
    }
  }

  /**
   * Translates various address parts to the standard properties used in the database.
   *
   * @function translateAddress
   * @param place
   * @return Object
   */
  function translateAddress(place) {
    let address = {
      street_number: false,
      route: false,
      city: false,
      region: false,
      region_long_name: false,
      postalcode: false,
      postalcode_suffix: false
    };

    let mutateObject = {};

    if (place && place.hasOwnProperty('address_components') && place.address_components instanceof Array) {
      place.address_components.forEach((component) => {
        let longType = $.type(component.long_name);
        let shortType = $.type(component.short_name);

        if (component.types.indexOf('street_number') > -1) {
          if (longType === 'string' && component.long_name.length > 0) {
            address.street_number = component.long_name.toUpperCase();
          } else {
            if (shortType === 'string' && component.short_name.length > 0) {
              address.street_number = component.short_name.toUpperCase();
            }
          }
        }

        if (component.types.indexOf('route') > -1) {
          if (longType === 'string' && component.long_name.length > 0) {
            address.route = component.long_name.toUpperCase();
          } else {
            if (shortType === 'string' && component.short_name.length > 0) {
              address.route = component.short_name.toUpperCase();
            }
          }
        }

        if (component.types.indexOf('locality') > -1) {
          if (longType === 'string' && component.long_name.length > 0) {
            address.city = component.long_name.toUpperCase();
          } else {
            if (shortType === 'string' && component.short_name.length > 0) {
              address.city = component.short_name.toUpperCase();
            }
          }
        }

        if (component.types.indexOf('administrative_area_level_1') > -1) {
          if (shortType === 'string' && component.short_name.length > 0) {
            address.region = component.short_name.toUpperCase();
          }

          if (longType === 'string' && component.long_name.length > 0) {
            address.region_long_name = component.long_name.toUpperCase();
          }
        }

        if (component.types.indexOf('postal_code') > -1) {
          if (longType === 'string' && component.long_name.length > 0) {
            address.postalcode = component.long_name.toUpperCase();
          } else {
            if (shortType === 'string' && component.short_name.length > 0) {
              address.postalcode = component.short_name.toUpperCase();
            }
          }
        }

        if (component.types.indexOf('postal_code_suffix') > -1) {
          if (longType === 'string' && component.long_name.length > 0) {
            address.postalcode_suffix = component.long_name.toUpperCase();
          } else {
            if (shortType === 'string' && component.short_name.length > 0) {
              address.postalcode_suffix = component.short_name.toUpperCase();
            }
          }
        }
      });
    }

    if (mutateObject && typeof mutateObject === 'object') {
      if (address.route) {
        if (address.street_number) {
          mutateObject.street_1 = address.street_number + ' ';
        } else {
          mutateObject.street_1 = '';
        }

        mutateObject.street_1 += address.route;
      }

      if (address.city) {
        mutateObject.city = address.city;
      }

      if (address.region) {
        mutateObject.region = address.region;
      }

      if (address.postalcode) {
        mutateObject.postalcode = address.postalcode;

        if (address.postalcode_suffix) {
          mutateObject.postalcode += '-' + address.postalcode_suffix;
        }
      }
    }

    return mutateObject;
  }

  /**
   * @function addCounsel
   */
  function addCounsel() {
    let index = Math.max(0, $('.counselRow').length);
    let nameSuffixOptions = '';
    let attorneyTypeOptions = '';

    forEach(window.attorneyTypes, (type) => {
      attorneyTypeOptions += '<option value="' + (typeof type === 'string' ? type : '') + '">' +
        (typeof type === 'string' ? type : '') + '</option>';
    });

    forEach(window.nameSuffixes, (suffix) => {
      nameSuffixOptions += '<option value="' + (typeof suffix === 'string' ? suffix : '') + '">' +
        (typeof suffix === 'string' ? suffix : '') + '</option>';
    });

    let attorneyMarkup = `
<div class="counselRow">
    <div class="floatleft">
        <label for="attorneys_type_${index}">Type:</label>
        <select id="attorneys_type_${index}" name="request[attorneys][${index}][type]">${attorneyTypeOptions}</select>
        <br>
        <label for="attorneys_bar_number_${index}">Bar #:</label>
        <input type="text" id="attorneys_bar_number_${index}" name="request[attorneys][${index}][bar_number]">
        <br>
        <label for="attorneys_last_name_${index}">Last Name:</label>
        <input type="text" id="attorneys_last_name_${index}" name="request[attorneys][${index}][last_name]">
        <br>
        <label for="attorneys_first_name_${index}">First Name:</label>
        <input type="text" id="attorneys_first_name_${index}" name="request[attorneys][${index}][first_name]">
        <br>
        <label for="attorneys_middle_name_${index}">Middle Name:</label>
        <input type="text" id="attorneys_middle_name_${index}" name="request[attorneys][${index}][middle_name]">
        <br>
        <label for="attorneys_suffix_${index}">Suffix:</label>
        <select id="attorneys_suffix_${index}" name="request[attorneys][${index}][suffix]">${nameSuffixOptions}</select>
        <br>
        <label for="attorneys_firm_${index}">Firm/Office:</label>
        <input type="text" id="attorneys_firm_${index}" name="request[attorneys][${index}][firm]">
        <br>
    </div>
    <div class="floatleft" style="margin-left: 40px;">
        <label for="attorneys_street1_${index}">Address:</label>
        <input type="text" id="attorneys_street1_${index}" name="request[attorneys][${index}][street_1]" autocomplete="off">
        <br>
        <label for="attorneys_street2_${index}">Address Line 2:</label>
        <input type="text" id="attorneys_street2_${index}" name="request[attorneys][${index}][street_2]">
        <br>
        <label for="attorneys_city_${index}">City:</label>
        <input type="text" id="attorneys_city_${index}" name="request[attorneys][${index}][city]">
        <br>
        <label for="attorneys_region_${index}">State:</label>
        <input type="text" id="attorneys_region_${index}" name="request[attorneys][${index}][region]">
        <br>
        <label for="attorneys_postalcode_${index}">ZIP:</label>
        <input type="text" id="attorneys_postalcode_${index}" name="request[attorneys][${index}][postalcode]">
        <br>
        <label for="attorneys_phone_${index}">Phone:</label>
        <input type="text" id="attorneys_phone_${index}"  name="request[attorneys][${index}][phone]">
        <br>
        <label for="attorneys_email_${index}">Email:</label>
        <input type="email" id="attorneys_email_${index}" name="request[attorneys][${index}][email]">
        <br>
    </div>
    <div class="floatleft">
        <label for="attorneys_is_requestor_${index}">Is The Requestor:</label>
        <input class="chkRequestor" type="checkbox" id="attorneys_is_requestor_${index}" name="request[attorneys][${index}][is_requestor]" value="1">
        <br>
        <label for="attorneys_is_pro_per_${index}">Pro-Per:</label>
        <input type="checkbox" id="attorneys_is_pro_per_${index}" name="request[attorneys][${index}][is_pro_per]" value="1">
        <br>
    </div>
    <br class="clear">
    <button type="button" class="deleteCounsel formbuttonSmall"><i class="fa fa-minus-circle"></i> Delete</button>
    <hr class="clear">
</div>
`;

    $('#counselContainer').append($(attorneyMarkup));

    try {
      decorateAddressCompletion(`request[attorneys][${index}]`);
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * @function addDeponent
   */
  function addDeponent() {
    let index = Math.max(0, $('.depRow').length);
    let deponentTypeOptions = '';

    forEach(window.deponentTypes, (type) => {
      deponentTypeOptions += '<option value="' + (typeof type === 'string' ? type : '') + '">' +
        (typeof type === 'string' ? type : '') + '</option>';
    });

    let deponentMarkup = `
<div class="depRow clear">
    <label for="deponents_type_${index}">Type:</label>
    <select id="deponents_type_${index}" name="request[deponents][${index}][type]">
        <option value="">Choose:</option>
        ${deponentTypeOptions}
    </select>
    <br>
    <label for="deponents_name_${index}">Deponent Name:</label>
    <input type="text" id="deponents_name_${index}" name="request[deponents][${index}][name]">
    <br>
    <label for="deponents_street1_${index}">Address:</label>
    <input type="text" id="deponents_street1_${index}" name="request[deponents][${index}][street_1]" autocomplete="off">
    <br>
    <label for="deponents_street2_${index}">Address Line 2:</label>
    <input type="text" id="deponents_street2_${index}" name="request[deponents][${index}][street_2]">
    <br>
    <label for="deponents_city_${index}">City:</label>
    <input type="text" id="deponents_city_${index}" name="request[deponents][${index}][city]">
    <br>
    <label for="deponents_region_${index}">State:</label>
    <input type="text" id="deponents_region_${index}" name="request[deponents][${index}][region]">
    <br>
    <label for="deponents_postalcode_${index}">ZIP:</label>
    <input type="text" id="deponents_postalcode_${index}" name="request[deponents][${index}][postalcode]">
    <br>
    <label for="deponents_phone_${index}">Phone</label>
    <input type="text" id="deponents_phone_${index}" class="" name="request[deponents][${index}][phone]">
    <br>
    <label for="deponents_include_billing_${index}">Include Billing Records:</label>
    <input type="checkbox" id="deponents_include_billing_${index}" name="request[deponents][${index}][include_billing]" value="1">
    <br>
    <br>
    <label for="deponents_include_images_${index}">Include Radiology Images:</label>
    <input type="checkbox" id="deponents_include_images_${index}" name="request[deponents][${index}][include_images]" value="1">
    <br>
    <br>
    <br>
    <label for="deponents_requested_info_${index}">Special Instructions:</label>
    <textarea id="deponents_requested_info_${index}" rows="2" cols="30" name="request[deponents][${index}][requested_info]"></textarea>
    <br>
    <label for="deponents_auth_file_${index}">Upload Authorization:</label>
    <input type="file" id="deponents_auth_file_${index}" name="request[deponents][${index}][auth_file]">
    <br class="clear">
    <br class="clear">
    <button type="button" class="deleteDep floatright formbuttonSmall"><i class="fa fa-minus-circle"></i> Delete Deponent</button>
    <hr class="clear">
</div>
`;

    $('#deponentContainer').append($(deponentMarkup));

    try {
      decorateAddressCompletion(`request[deponents][${index}]`);
    } catch (err) {
      console.error(err);
    }
  }
});